import axios from "@/utils/axios.js";

/**
 * Получение списка билетов
 */
function getTicketsAll() {
    return new Promise((resolve, reject) => {
        axios
            .get("tickets-numbers")
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export {
    getTicketsAll
}